// ===============================
// Vendor libraries
// ===============================

// ===============================
// Swiper imports
// ===============================
import Swiper from "swiper";
import { Navigation, Pagination, Autoplay, EffectFade } from "swiper/modules";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-fade";

// Register modules
Swiper.use([Navigation, Pagination, Autoplay, EffectFade]);

// Expose globally
window.Swiper = Swiper;

// ===============================
// Bootstrap imports
// ===============================
import * as bootstrap from "bootstrap";
import "@popperjs/core";
window.bootstrap = bootstrap;

// ===============================
// Sections
// ===============================
import "./sections/activity-gallery.js";
import "./sections/inquiry-form.js";
import "./sections/contact-form.js";
import "./sections/inquiry-modal.js";
import "./sections/sidebar.js";
import "./sections/careers.js";
import "./sections/job-details.js";
import "./sections/job-apply.js";
import "./sections/steam.js";
import "./sections/delivery-support.js";
import "./sections/blog-share.js";

// ===============================
// Pages
// ===============================
import "./pages/inquiry-page.js";
import "./pages/blogs-pagination.js";

// ===============================
// Animations (optional)
import "./animations/smooth-scroll.js";

document.addEventListener("DOMContentLoaded", () => {
  console.log("Site loaded!");

  // ------------------------------------------------------------
  // HEADER
  const header = document.querySelector("header");
  const scrollThreshold = 60;

  window.addEventListener("scroll", function () {
    if (window.scrollY > scrollThreshold) {
      header.classList.add("header_fixed");
    } else {
      header.classList.remove("header_fixed");
    }
  });

  // ------------------------------------------------------------
  // SLIDERS

  // HERO
  new Swiper(".heroSwiper", {
    modules: [Navigation, Pagination, Autoplay, EffectFade],
    loop: true,
    effect: "fade",
    fadeEffect: { crossFade: true },
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
    },
    allowTouchMove: false,
    simulateTouch: false,
    speed: 800,
    pagination: {
      el: ".hero-banner .swiper-pagination",
      clickable: true,
    },
  });

  // TRUST BY SLIDER
  new Swiper(".trust-by-slider", {
    loop: true,
    autoplay: true,
    slidesPerView: 3,
    spaceBetween: 10,
    breakpoints: {
      576: {
        slidesPerView: 5,
      },
      768: {
        slidesPerView: 7,
      },
      1200: {
        slidesPerView: 9,
      },
    },
    // navigation: {
    //   nextEl: ".trust-by-slider .swiper-button-next",
    //   prevEl: ".trust-by-slider .swiper-button-prev",
    // }
  });

  // CLIENT TESTIMONIALS
  const testimonialSwiper = new Swiper(".testimonialSwiper", {
    slidesPerView: 1,
    spaceBetween: 24,
    loop: true,
    autoplay: {
      delay: 4500,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    speed: 700,
    navigation: {
      nextEl: ".testimonial-slider-wrapper .swiper-button-next",
      prevEl: ".testimonial-slider-wrapper .swiper-button-prev",
    },
    breakpoints: {
      992: {
        slidesPerView: 3,
        spaceBetween: 24,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      0: {
        slidesPerView: 1,
        spaceBetween: 16,
      },
    },
  });

  // Client Testimonials Video Modal
  const testimonialVideoCards = document.querySelectorAll(
    ".client-testimonials .video-card .video-thumbnail-wrap"
  );
  if (testimonialVideoCards.length) {
    let modal = document.getElementById("testimonialVideoModal");
    if (!modal) {
      modal = document.createElement("div");
      modal.id = "testimonialVideoModal";
      modal.className = "testimonial-video-modal";
      modal.innerHTML = `
        <div class="modal-backdrop-custom"></div>
        <div class="modal-dialog-custom">
          <button type="button" class="modal-close-btn" aria-label="Close video">
            <i class="fa-solid fa-xmark"></i>
          </button>
          <video id="testimonialVideoPlayer" controls playsinline></video>
        </div>
      `;
      document.body.appendChild(modal);
    }

    const player = modal.querySelector("#testimonialVideoPlayer");
    const closeBtn = modal.querySelector(".modal-close-btn");
    const backdrop = modal.querySelector(".modal-backdrop-custom");

    const closeVideo = () => {
      modal.classList.remove("active");
      player.pause();
      player.removeAttribute("src");
      player.load();
      document.body.style.overflow = "";
      if (testimonialSwiper && testimonialSwiper.autoplay) {
        testimonialSwiper.autoplay.start();
      }
    };

    closeBtn.addEventListener("click", closeVideo);
    backdrop.addEventListener("click", closeVideo);
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && modal.classList.contains("active")) {
        closeVideo();
      }
    });

    testimonialVideoCards.forEach((card) => {
      card.addEventListener("click", () => {
        const videoUrl = card.getAttribute("data-video-url");
        if (!videoUrl) return;
        player.src = videoUrl;
        modal.classList.add("active");
        document.body.style.overflow = "hidden";
        player.play().catch(() => { });
        if (testimonialSwiper && testimonialSwiper.autoplay) {
          testimonialSwiper.autoplay.stop();
        }
      });
    });
  }

  // CURRICULUM SLIDER
  new Swiper(".curriculumHeroSwiper", {
    modules: [EffectFade, Navigation, Pagination, Autoplay],
    effect: "fade",
    fadeEffect: { crossFade: true },
    loop: true,
    autoplay: false,
    speed: 800,
  });

  // LAB OVERVIEW THUMB SLIDER
  new Swiper(".lab-overview-slider", {
    loop: true,
    autoplay: false,
    slidesPerView: 4,
    spaceBetween: 10,
    breakpoints: {
      576: {
        slidesPerView: 5,
      },
      768: {
        slidesPerView: 5,
      },
      992: {
        slidesPerView: 7,
      },
      1200: {
        slidesPerView: 8,
      },
    },
    navigation: {
      nextEl: ".lab-overview-slider .swiper-button-next",
      prevEl: ".lab-overview-slider .swiper-button-prev",
    },
  });

  // INFO SLIDER
  document.querySelectorAll(".infoSwiper").forEach((swiperEl, index) => {
    const parentContainer = swiperEl.closest(".info-slider") || swiperEl;
    const initialSlideIndex = index === 1 ? 6 : 4;

    new Swiper(swiperEl, {
      slidesPerView: 3,
      spaceBetween: 24,
      loop: true,
      initialSlide: initialSlideIndex,
      navigation: {
        nextEl: parentContainer.querySelector(".swiper-button-next"),
        prevEl: parentContainer.querySelector(".swiper-button-prev"),
      },
      breakpoints: {
        1200: {
          slidesPerView: 3.5,
          centeredSlides: true,
          spaceBetween: 24,
        },
        992: {
          slidesPerView: 3,
          centeredSlides: false,
          spaceBetween: 20,
        },
        576: {
          slidesPerView: 2,
          centeredSlides: false,
          spaceBetween: 16,
        },
        0: {
          slidesPerView: 1.2,
          centeredSlides: true,
          spaceBetween: 12,
        },
      },
    });
  });

  // ------------------------------------------------------------
  const dropdown = document.querySelector("#headerLoginDropdown");
  const dropdownToggle = dropdown.querySelector('[data-bs-toggle="dropdown"]');
  const bsDropdown = new bootstrap.Dropdown(dropdownToggle);

  let hideTimeout;

  dropdown.addEventListener("mouseenter", () => {
    clearTimeout(hideTimeout);
    bsDropdown.show();
  });

  dropdown.addEventListener("mouseleave", () => {
    hideTimeout = setTimeout(() => {
      bsDropdown.hide();
    }, 150); // small delay prevents accidental close
  });

  // ------------------------------------------------------------
  const navDropdown = document.querySelector("#navDropdown");
  const navDropdownToggle = navDropdown.querySelector(
    '#navDropdown [data-bs-toggle="dropdown"]',
  );
  const navBsDropdown = new bootstrap.Dropdown(navDropdownToggle);

  let navHideTimeout;

  navDropdown.addEventListener("mouseenter", () => {
    clearTimeout(navHideTimeout);
    navBsDropdown.show();
  });

  navDropdown.addEventListener("mouseleave", () => {
    navHideTimeout = setTimeout(() => {
      navBsDropdown.hide();
    }, 150); // small delay prevents accidental close
  });
  // ------------------------------------------------------------

  // BACK TO TOP BUTTON FUNCTION
  const backToTop = document.getElementById("backToTop");

  // Show/Hide button on scroll
  window.addEventListener("scroll", () => {
    if (window.scrollY > 400) {
      backToTop.classList.add("visible");
    } else {
      backToTop.classList.remove("visible");
    }
  });

  // Smooth scroll to top
  backToTop.addEventListener("click", () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  });

  /*==================================
      Button Icon Draw
====================================*/
  // Select all elements with class "tg-svg"
  var svgIconBoxes = document.querySelectorAll(".tg-svg");

  svgIconBoxes.forEach(function (box) {
    var svgIcon = box.querySelector(".svg-icon");
    var id = svgIcon.getAttribute("id");
    var icon = svgIcon.getAttribute("data-svg-icon");

    if (!id || !icon) return;
    // Initialize Vivus animation
    var vivus = new Vivus(id, {
      duration: 80,
      file: icon,
    });

    // Replay animation on mouse enter (for each icon)
    box.addEventListener("mouseenter", function () {
      vivus.reset().play();
    });

    // Replay animation when mouse enters the body (same as $("body").on('mouseenter'))
    document.body.addEventListener("mouseenter", function () {
      vivus.reset().play();
    });
  });

  // ------------------------------------------------------------
  // Check if custom cursor element exists
  if (document.querySelector(".custom-cursor")) {
    const cursor = document.querySelector(".custom-cursor__cursor");
    const cursorInner = document.querySelector(".custom-cursor__cursor-two");
    const links = document.querySelectorAll("a");
    const baseBg = document.querySelectorAll(".base_bg");

    // Move outer cursor
    document.addEventListener("mousemove", (e) => {
      cursor.style.transform = `translate3d(calc(${e.clientX}px - 50%), calc(${e.clientY}px - 50%), 0)`;
    });

    // Move inner cursor
    document.addEventListener("mousemove", (e) => {
      cursorInner.style.left = e.clientX + "px";
      cursorInner.style.top = e.clientY + "px";
    });

    // Mouse down effect
    document.addEventListener("mousedown", () => {
      cursor.classList.add("click");
      cursorInner.classList.add("custom-cursor__innerhover");
    });

    // Mouse up effect
    document.addEventListener("mouseup", () => {
      cursor.classList.remove("click");
      cursorInner.classList.remove("custom-cursor__innerhover");
    });

    // Hover effect on links
    links.forEach((link) => {
      link.addEventListener("mouseover", () => {
        cursor.classList.add("custom-cursor__hover");
      });
      link.addEventListener("mouseleave", () => {
        cursor.classList.remove("custom-cursor__hover");
      });
    });

    // Hover effect on white background elements
    baseBg.forEach((el) => {
      el.addEventListener("mouseover", () => {
        cursor.classList.add("custom-cursor-white__hover");
        cursorInner.classList.add("custom-cursor-white__innerhover");
      });
      el.addEventListener("mouseleave", () => {
        cursor.classList.remove("custom-cursor-white__hover");
        cursorInner.classList.remove("custom-cursor-white__innerhover");
      });
    });
  }

  // ------------------------------------------------------------
  // VIDEO PLAY/PAUSE TOGGLE
  const videoWrapper = document.querySelector(".video-wrapper");
  if (videoWrapper) {
    const video = videoWrapper.querySelector(".home_video");
    const overlayIcon = videoWrapper.querySelector(".video-overlay i");

    videoWrapper.addEventListener("click", () => {
      if (video.paused) {
        video.play();
        overlayIcon.classList.remove("play");
        overlayIcon.classList.add("pause");

        // briefly show icon when resuming
        videoWrapper.classList.add("paused");
        setTimeout(() => videoWrapper.classList.remove("paused"), 500);
      } else {
        video.pause();
        overlayIcon.classList.remove("pause");
        overlayIcon.classList.add("play");
        videoWrapper.classList.add("paused");
      }
    });
  }

  // ------------------------------------------------------------

  // GALLERY THUMBNAIL TO HOTSPOT LINKING

  /* =============================
   1️⃣ Initialize OpenSeadragon
============================= */
  let osdViewerContainer = document.getElementById("osd-viewer");
  if (!osdViewerContainer) return; // Exit if no viewer container found

  const viewer = OpenSeadragon({
    id: "osd-viewer",
    prefixUrl:
      "https://cdnjs.cloudflare.com/ajax/libs/openseadragon/5.0.1/images/",
    tileSources: {
      type: "image",
      url: "assets/images/resources/infrastructure-banner-2.png",
    },
    showFullPageControl: false,
    // --- Default zoom behaviour ---
    minZoomLevel: 1, // Prevent zooming out too far
    defaultZoomLevel: 1.3, // ⬅️ Slightly zoomed in when loaded
    visibilityRatio: 1.0, // Keep image edges visible initially
    constrainDuringPan: true,

    // --- Disable user zoom interactions ---
    gestureSettingsMouse: {
      clickToZoom: false,
      dblClickToZoom: false,
      scrollToZoom: false,
    },
    gestureSettingsTouch: {
      pinchToZoom: false,
      dblTapToZoom: false,
    },
    showNavigator: false,
  });

  /* =============================
     2️⃣ Hotspot definitions (relative coords)
  ============================= */
  const hotspots = [
    { id: 0, x: 0.2000, y: 0.2341, label: "STEM MODELS", zoom: 6 },
    { id: 1, x: 0.42, y: 0.25, label: "STORAGE UNIT", zoom: 5 },
    { id: 2, x: 0.5426, y: 0.2726, label: "3D PRINTER", zoom: 6 },
    { id: 3, x: 0.7013, y: 0.2224, label: "TV" },
    { id: 4, x: 0.6100, y: 0.2656, label: "PODIUM", zoom: 6 },
    { id: 5, x: 0.5663, y: 0.3100, label: "WORK STATION", zoom: 4 },
    { id: 6, x: 0.5442, y: 0.3603, label: "CABINETS", zoom: 7 },
    { id: 7, x: 0.3800, y: 0.3100, label: "ELECTRICAL POINTS", zoom: 6 },
    { id: 8, x: 0.3620, y: 0.2695, label: "TABLETS", zoom: 8 },
  ];

  /* =============================
     3️⃣ Add hotspots after image loads
  ============================= */
  viewer.addHandler("open", () => {
    hotspots.forEach((h) => {
      const el = document.createElement("div");
      el.className = "hotspot";
      el.dataset.id = h.id;
      el.innerHTML = `<span class="dot"></span><p>${h.label}</p>`;
      el.addEventListener("click", () => {
        highlightHotspot(h.id);
        highlightThumbnail(h.id);
        focusHotspotUsingFitBoundsSmooth(h, h.zoom || 2.5);
      });
      viewer.addOverlay({
        element: el,
        location: new OpenSeadragon.Point(h.x, h.y),
        placement: OpenSeadragon.Placement.CENTER,
      });
    });
  });

  viewer.addHandler("canvas-click", function (event) {
    const webPoint = event.position; // click position on viewer
    const viewportPoint = viewer.viewport.pointFromPixel(webPoint);
    const imagePoint =
      viewer.viewport.viewportToImageCoordinates(viewportPoint);

    const x = viewportPoint.x.toFixed(4);
    const y = viewportPoint.y.toFixed(4);

    console.log(`Clicked position: x: ${x}, y: ${y}`);
  });

  viewer.addHandler("canvas-drag", function (event) {
    event.preventDefaultAction = true; // block panning
  });

  /* =============================
     4️⃣ Focus on hotspot
  ============================= */

  function focusHotspotUsingFitBoundsSmooth(
    h,
    targetZoom = 2.5,
    duration = 400,
  ) {
    const vp = viewer.viewport;
    const aspect = vp.getAspectRatio();

    // Calculate bounds that represent the zoom target
    const halfWidth = 0.5 / targetZoom;
    const halfHeight = halfWidth / aspect;
    const bounds = new OpenSeadragon.Rect(
      h.x - halfWidth,
      h.y - halfHeight,
      halfWidth * 2,
      halfHeight * 2,
    );

    // Animate manually with viewport.applyConstraints() for smoother easing
    const startBounds = vp.getBounds();
    const startTime = performance.now();

    function animate(time) {
      const progress = Math.min((time - startTime) / duration, 1);
      // smooth easing (easeInOut)
      const t = 0.5 - Math.cos(progress * Math.PI) / 2;

      const interpolated = new OpenSeadragon.Rect(
        startBounds.x + (bounds.x - startBounds.x) * t,
        startBounds.y + (bounds.y - startBounds.y) * t,
        startBounds.width + (bounds.width - startBounds.width) * t,
        startBounds.height + (bounds.height - startBounds.height) * t,
      );

      vp.fitBounds(interpolated, false); // update frame by frame (no internal animation)

      if (progress < 1) {
        requestAnimationFrame(animate);
      } else {
        vp.fitBounds(bounds, false); // final precise alignment
      }
    }

    requestAnimationFrame(animate);
  }

  function highlightHotspot(id) {
    // Remove active class from all hotspots
    document
      .querySelectorAll(".hotspot")
      .forEach((hs) => hs.classList.remove("active"));

    // Find matching hotspot and activate it
    const activeHotspot = document.querySelector(`.hotspot[data-id='${id}']`);
    if (activeHotspot) activeHotspot.classList.add("active");
  }

  function highlightThumbnail(id) {
    // Remove active class from all thumbnails
    document
      .querySelectorAll(".thumb-gallery .swiper-slide")
      .forEach((slide) => {
        slide.classList.remove("active");
      });

    // Add active class to matching thumb
    const activeThumb = document.querySelector(
      `.thumb-gallery .swiper-slide[data-id='${id}']`,
    );
    if (activeThumb) activeThumb.classList.add("active");
  }

  /* =============================
     5️⃣ Swiper gallery linking
  ============================= */

  // When clicking a thumbnail, zoom to matching hotspot
  document
    .querySelectorAll(".thumb-gallery .swiper-slide")
    .forEach((thumb, i) => {
      thumb.addEventListener("click", () => {
        const h = hotspots[i];
        if (h) {
          highlightHotspot(h.id);
          highlightThumbnail(h.id);
          focusHotspotUsingFitBoundsSmooth(h, h.zoom || 2.5);
        }
      });
    });

  // To clear all highlights when clicking outside image or gallery:
  document.addEventListener("click", (e) => {
    const isHotspot = e.target.closest(".hotspot");
    const isThumb = e.target.closest(".thumb-gallery");
    const isViewer = e.target.closest("#osd-viewer");
    if (!isHotspot && !isThumb && !isViewer) {
      // Remove highlight
      document
        .querySelectorAll(".hotspot")
        .forEach((hs) => hs.classList.remove("active"));

      // Remove thumbnail highlight
      document
        .querySelectorAll(".thumb-gallery .swiper-slide")
        .forEach((slide) => slide.classList.remove("active"));

      // Smoothly reset zoom
      // resetZoomSmooth(1.3);
      viewer.viewport.goHome();
    }
  });
});
